@let _title = title() | optionalAsync;

<button
  class="logo-button"
  [title]="_title"
  (click)="onClick()">
  @if (!hasCustomLogo()) {
    @if (logo(); as _logo) {
      <evc-icon
        class="logo"
        size="logo"
        [imgUrl]="_logo" />
    }
    @if (_title) {
      <span class="title">{{ _title }}</span>
    }
  }

  <span
    class="custom-logo"
    #customLogo>
    <ng-content
      #customLogo
      select="[custom-logo]" />
  </span>
</button>
